import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilterOption } from '../filter-select/filter-select';

@Component({
  selector: 'app-option-select',
  imports: [CommonModule, MatMenuModule],
  templateUrl: './option-select.html',
  styleUrl: './option-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OptionSelect),
      multi: true,
    },
  ],
})
export class OptionSelect implements ControlValueAccessor {
  @Input() options: FilterOption[] = [];

  value = '';
  disabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  get selectedLabel(): string {
    return this.options.find((o) => o.value === this.value)?.label ?? this.value;
  }

  writeValue(value: string): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
